import type { RootState } from 'application/store';
import { ICreateAdCampaignState } from './types';

export const selectCreateAdCampaign = (state: RootState): ICreateAdCampaignState => state?.createAdCampaign;

export const selectStep = (state: RootState) => state.createAdCampaign.step;

export const selectCampaignType = (state: RootState) => state.createAdCampaign.campaignType;

export const selectCampaignName = (state: RootState) => state.createAdCampaign.campaignName;

export const selectValueByMode = (state: RootState) => state.createAdCampaign.valueByMode;

export const selectStartDate = (state: RootState) => state.createAdCampaign.startDate;

export const selectEndDate = (state: RootState) => state.createAdCampaign.endDate;

export const selectIsInfinitely = (state: RootState) => state.createAdCampaign.isInfinitely;

export const selectWeekdays = (state: RootState) => state.createAdCampaign.weekdays;

export const selectDayStartTime = (state: RootState) => state.createAdCampaign.dayStartTime;

export const selectDayEndTime = (state: RootState) => state.createAdCampaign.dayEndTime;

export const selectMediaType = (state: RootState) => state.createAdCampaign.mediaType;

export const selectSelectedTags = (state: RootState) => state.createAdCampaign.selectedTags;

export const selectSelectedPointIds = (state: RootState) => state.createAdCampaign.selectedPointIds;

export const selectPromoStatuses = (state: RootState) => state.createAdCampaign.promoStatuses;

export const selectPromoStatusesCount = (state: RootState) => selectPromoStatuses(state).length;

export const selectPromoTimesById = (state: RootState) => state.createAdCampaign.promoTimesById;

export const selectIsInstantAdCampaignDisabled = (state: RootState) => selectPromoStatusesCount(state) > 1;
